import {DataTable} from '@/components-v2'
import {useProductListForModal} from '@/hooks/promotion/useProductListForModal'
import {useDataTableV2} from '@/hooks/useDataTableV2'
import {productsTableHeader} from '@/services/MockData/Promotions/ProductTableColumns'
import {PRODUCT_ID_TYPE, COMBO_ID_TYPE, BuyType} from '@/utils/constants/promotionConstants'
import {comboProductsTableHeader} from '@/utils/productCombo/productComboConstants'
import {useCallback, useMemo} from 'react'
import '@/containers/Promotions/components/SelectionModalContent/ProductIdContent/ProductIdContent.styles.css'

const ProductIdContentV2 = ({
  onSelection,
  combination,
  setCombination,
  isExclude,
  selectedValues = [],
  type = BuyType.PRODUCT_ID,
}) => {
  const isCombo = type === BuyType.COMBO_ID

  const {
    pageIndex,
    sorting,
    activeFilters,
    onPageIndexChange,
    sortingHandler,
    onColumnFiltersChange,
    handleResetAll,
  } = useDataTableV2({
    defaultPageSize: 10,
    getRowId: row => row.productId,
  })

  const {products, isLoading} = useProductListForModal(activeFilters, sorting, pageIndex, type)

  const columns = useMemo(() => (isCombo ? comboProductsTableHeader : productsTableHeader), [isCombo])

  const initialRowSelection = useMemo(() => {
    if (!selectedValues?.length) return {}
    return selectedValues.reduce((acc, sv) => ({...acc, [sv.id]: true}), {})
  }, [selectedValues])

  const rowSelectionStateUpdater = useCallback(
    selectedTableRows => {
      const rawRows = selectedTableRows.map(row => row.original ?? row)
      const values = rawRows
        .map(row => ({
          id: row.productId || '',
          displayText: row.productName || row.name || '',
        }))
        .filter(item => item.id)

      if (values.length > 0) {
        onSelection({itemType: isCombo ? COMBO_ID_TYPE : PRODUCT_ID_TYPE, values})
      } else {
        onSelection({itemType: isCombo ? COMBO_ID_TYPE : PRODUCT_ID_TYPE, values: []})
      }
    },
    [onSelection, isCombo]
  )

  const resetFilterButtonOptions = useMemo(
    () => ({
      onFiltersReset: () => {
        handleResetAll()
        onSelection({itemType: isCombo ? COMBO_ID_TYPE : PRODUCT_ID_TYPE, values: []})
      },
      text: 'Reset All',
    }),
    [handleResetAll, onSelection, isCombo]
  )

  return (
    <div className="product-id-content-wrapper">
      <DataTable
        columns={columns}
        data={products?.data || []}
        isLoading={isLoading}
        pageSize={10}
        totalRowsCount={products?.totalRecords || 0}
        pageIndex={pageIndex}
        onPageIndexChange={onPageIndexChange}
        sortingHandler={sortingHandler}
        onColumnFiltersChange={onColumnFiltersChange}
        rowSelectionStateUpdater={rowSelectionStateUpdater}
        selection="multiple"
        initialRowSelection={initialRowSelection}
        getRowId={row => row.productId}
        resetFilterButtonOptions={resetFilterButtonOptions}
        manualPagination={true}
        manualSorting={true}
        manualFiltering={true}
        showColumnFilters={true}
      />
    </div>
  )
}

export default ProductIdContentV2
